import React, { ComponentPropsWithRef, FC } from 'react'

import clsx from 'clsx'

import { Icon, Txt } from 'src/components/atoms'

type DivProps = ComponentPropsWithRef<'div'>
type Props = DivProps & {
  iconPath: string
  text: string
  type?: 'normal' | 'error'
}

export const CommonContentAssetMenuItem: FC<Props> = ({
  iconPath,
  text,
  type = 'normal',
  ...otherProps
}) => {
  return (
    <div {...otherProps}>
      <div className={clsx('tw-flex', type === 'error' && 'tw-text-errorRed-default')}>
        <Icon
          path={iconPath}
          size="--r0"
          className={clsx(type === 'normal' && 'tw-text-standardText-secondary')}
        />
        <Txt className="tw-break-keep tw-ml-s-2">{text}</Txt>
      </div>
    </div>
  )
}
